var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe_div"},[_c('iframe',{ref:"iframeRef",staticClass:"iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }